var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pickup-list-item",
      on: {
        click: function($event) {
          return _vm.$emit("select")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "pickup-list-item__head" },
        [
          _vm.store.type === "store"
            ? [
                _c(
                  "div",
                  { staticClass: "pickup-list-item__head-store-title" },
                  [
                    _vm._v("\n        Магазин\n        "),
                    _c("f-sprite-icon", {
                      attrs: { "icon-link": _vm.$options.icons.IconLogo.id }
                    })
                  ],
                  1
                )
              ]
            : [
                _c(
                  "div",
                  { staticClass: "pickup-list-item__head-alt-title" },
                  [
                    _vm.store.type === "postamat"
                      ? [
                          _c("f-sprite-icon", {
                            attrs: {
                              "icon-link": _vm.$options.icons.IconTerminal.id
                            }
                          })
                        ]
                      : [
                          _c("f-sprite-icon", {
                            attrs: {
                              "icon-link": _vm.$options.icons.IconPickup.id
                            }
                          })
                        ],
                    _c("span", [_vm._v(_vm._s(_vm.store.name))])
                  ],
                  2
                )
              ],
          _c("products-count-tag", {
            staticClass: "pickup-list-item__products-count",
            attrs: {
              count: _vm.store.availableLinesCount,
              total: _vm.ids.length
            }
          })
        ],
        2
      ),
      _vm.store.metro.length
        ? _c(
            "div",
            { staticClass: "pickup-list-item__metro" },
            _vm._l(_vm.store.metro, function(metro) {
              return _c("div", { key: metro.id }, [
                _c("span", { style: { backgroundColor: metro.line.color } }),
                _vm._v(_vm._s(metro.name) + "\n    ")
              ])
            }),
            0
          )
        : _vm._e(),
      _c("div", { staticClass: "pickup-list-item__title" }, [
        _c("span", { staticClass: "pickup-list-item__address" }, [
          _vm._v(_vm._s(_vm.store.address))
        ]),
        _vm.distance
          ? _c("span", { staticClass: "pickup-list-item__distance" }, [
              _vm._v(_vm._s(_vm.distance))
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "pickup-list-item__info" }, [
        _vm.checkLabels(_vm.store)
          ? _c(
              "div",
              { staticClass: "pickup-list-item__info-labels" },
              [
                _vm.store.needPrepay
                  ? _c("tag", {
                      attrs: {
                        title: "100%&nbsp;&nbsp;предоплата",
                        width: "120px",
                        color: "#ffb71b"
                      }
                    })
                  : _vm._e(),
                _vm.checkQrCodeRequirement(_vm.store)
                  ? _c("tag", {
                      attrs: {
                        title: "Вход по QR",
                        width: "80px",
                        color: "#C1E0E0"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "pickup-list-item__info-schedule" }, [
          _vm._v(
            "\n      Часы работы: " +
              _vm._s(_vm._f("parseWorkSchedule")(_vm.store)) +
              "\n    "
          )
        ])
      ]),
      _c("div", { staticClass: "pickup-list-item__bottom" }, [
        _c("div", { staticClass: "pickup-list-item__bottom-icons" }, [
          _vm.hasFitting
            ? _c(
                "div",
                { staticClass: "pickup-list-item__bottom-icon" },
                [
                  _c("f-sprite-icon", {
                    attrs: { "icon-link": _vm.$options.icons.IconFitting.id }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.hasRefund
            ? _c(
                "div",
                { staticClass: "pickup-list-item__bottom-icon" },
                [
                  _c("f-sprite-icon", {
                    attrs: { "icon-link": _vm.$options.icons.IconReturn.id }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.hasCardPay
            ? _c(
                "div",
                { staticClass: "pickup-list-item__bottom-icon" },
                [
                  _c("f-sprite-icon", {
                    attrs: { "icon-link": _vm.$options.icons.IconCard.id }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _vm.store.availableOn
          ? _c("div", { staticClass: "pickup-list-item__bottom-access" }, [
              _c("span", [_vm._v("Можно забрать:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm._f("date")(_vm.store.availableOn, { showYear: true })
                  ) +
                  "\n    "
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }